module.exports = __webpack_public_path__ + "static/img/mobile-web-02-img@t.05c8b58.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life-smart-phone-sales/mobile-web-02-img@t.png
// module id = emK4
// module chunks = 0